import { Link } from "react-router-dom";

export const Logo = ({ size = "md" }) => {
  const sizes = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-2xl",
  };
  return (
    <Link
      to="/"
      data-testid="logo-link"
      aria-label="consulting-ia.ch — Accueil"
      className={`flex items-center gap-2 font-extrabold ${sizes[size]} tracking-tight`}
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      <span className="pulse-dot" />
      <span className="flex items-center leading-none whitespace-nowrap">
        <span className="title-text">consulting</span>
        <span className="accent-text">-ia</span>
        <span className="title-text">.ch</span>
      </span>
    </Link>
  );
};
